"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsreducerFunction = exports.settingsActions = exports.settingsState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
var i18n_1 = require("../i18n");
exports.initialState = {
    language: i18n_1.langTypes.FR,
    loading: false,
    theme: 'saur',
    params: null,
    isCookiesSet: false,
    errorMsg: null,
    cookies: [
        {
            id: 1,
            rule: 'session',
            accepted: true
        },
        {
            id: 2,
            rule: 'analytic',
            accepted: true
        }
    ],
    userBrandParametersLoading: false,
    userBrandParametersLoadSuccess: false,
    userBrandParametersErrorMessage: null,
    userBrandParameters: null,
    fetchRgpdMentions: {
        loading: false,
        success: false,
        rgpdText: null,
        errorCode: null,
        errorMessage: null
    }
};
var settingsState = /** @class */ (function (_super) {
    __extends(settingsState, _super);
    function settingsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    settingsState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    settingsState.prototype.setTheme = function (_theme) {
        this.draftState.theme = _theme;
    };
    settingsState.prototype.getBrandData = function () {
        this.draftState.loading = true;
    };
    settingsState.prototype.getBrandDataSuccess = function (_a) {
        var params = _a.params, theme = _a.theme;
        this.draftState.loading = false;
        this.draftState.theme = theme;
        this.draftState.params = params;
        this.draftState.errorMsg = null;
    };
    settingsState.prototype.getBrandDataError = function (errorMsg) {
        this.draftState.loading = false;
        this.draftState.errorMsg = errorMsg;
    };
    settingsState.prototype.setLanguage = function (lang) {
        this.draftState.language = lang;
    };
    settingsState.prototype.updateCookiesSetting = function (cookiesSettings) {
        this.draftState.cookies = cookiesSettings;
        this.draftState.isCookiesSet = true;
    };
    /**
     * Récuperer la clause rgpd depuis le back pour le parcours d'abonnement
     */
    settingsState.prototype.getRgpdMentions = function () {
        this.draftState.fetchRgpdMentions.loading = true;
        this.draftState.fetchRgpdMentions.errorCode = null;
        this.draftState.fetchRgpdMentions.errorMessage = null;
        this.draftState.fetchRgpdMentions.success = false;
        this.draftState.fetchRgpdMentions.rgpdText = null;
    };
    settingsState.prototype.getRgpdMentionsSuccess = function (rgpd) {
        this.draftState.fetchRgpdMentions.loading = false;
        this.draftState.fetchRgpdMentions.errorCode = null;
        this.draftState.fetchRgpdMentions.errorMessage = null;
        this.draftState.fetchRgpdMentions.success = true;
        this.draftState.fetchRgpdMentions.rgpdText = rgpd;
    };
    settingsState.prototype.getRgpdMentionsFailure = function (errorCode, errorMessage) {
        this.draftState.fetchRgpdMentions.loading = false;
        this.draftState.fetchRgpdMentions.errorCode = errorCode;
        this.draftState.fetchRgpdMentions.errorMessage = errorMessage;
        this.draftState.fetchRgpdMentions.success = false;
        this.draftState.fetchRgpdMentions.rgpdText = null;
    };
    settingsState.prototype.getUserBrandParameters = function () {
        this.draftState.userBrandParametersLoading = true;
        this.draftState.userBrandParametersLoadSuccess = false;
        this.draftState.userBrandParametersErrorMessage = null;
    };
    settingsState.prototype.getUserBrandParametersSuccess = function (brandParameters) {
        this.draftState.userBrandParametersLoading = false;
        this.draftState.userBrandParametersLoadSuccess = true;
        this.draftState.userBrandParametersErrorMessage = null;
        this.draftState.userBrandParameters = brandParameters;
    };
    settingsState.prototype.getUserBrandParametersFailure = function (errorMsg) {
        this.draftState.userBrandParametersLoading = false;
        this.draftState.userBrandParametersLoadSuccess = false;
        this.draftState.userBrandParametersErrorMessage = errorMsg;
    };
    settingsState.prototype.getMobileBrandData = function (brandId) {
        this.draftState.loading = true;
    };
    settingsState.prototype.getMobileBrandDataSuccess = function (_a) {
        var params = _a.params, theme = _a.theme;
        this.draftState.loading = false;
        this.draftState.theme = theme;
        this.draftState.params = params;
        this.draftState.errorMsg = null;
    };
    settingsState.prototype.getMobileBrandDataError = function (errorMsg) {
        this.draftState.loading = false;
        this.draftState.errorMsg = errorMsg;
    };
    settingsState.prototype.getMobileUserBrandParameters = function (brandId) {
        this.draftState.userBrandParametersLoading = true;
        this.draftState.userBrandParametersLoadSuccess = false;
        this.draftState.userBrandParametersErrorMessage = null;
    };
    return settingsState;
}(immer_reducer_1.ImmerReducer));
exports.settingsState = settingsState;
exports.settingsActions = (0, immer_reducer_1.createActionCreators)(settingsState);
exports.settingsreducerFunction = (0, immer_reducer_1.createReducerFunction)(settingsState, exports.initialState);
